import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';

import { ReviewComment } from '@/types/Review';
import { Seller } from '@/types/Seller';
import { shortFormatDate } from '@/utils/dates';
import { getAuctioneerLogoUrl, getAuctioneerLogoUrlPlaceholder } from '@/utils/urls';

type Props = {
    comment: ReviewComment;
    logoId: Seller['logoId'];
};

export const ReviewedPageComment = ({ comment, logoId }: Props) => {
    const { comment: commentText, commentId, commentSubmittedTS, privacyStatus, userDisplayName } = comment;

    const logoUrl = logoId ? getAuctioneerLogoUrl(logoId, 48) : '';
    const logoUrlPlaceholder = logoId ? getAuctioneerLogoUrlPlaceholder(logoId, 48) : '';

    return (
        <div
            aria-label={privacyStatus}
            className="mt-sm flex items-start border-t border-border-secondary py-sm"
            key={commentId}
        >
            <div className="mr-md h-xl w-xl border border-border-secondary bg-background-primary">
                <div className="flex h-xl max-h-full w-xl max-w-full items-center justify-center">
                    <img
                        alt={`${userDisplayName} Logo`}
                        className="max-h-[95%] max-w-[95%]"
                        // The img element in question was taken from un-DRY versions of the comment UI elements.
                        // `img` doesn't have a `placeholder` prop, but I'm hesitant to mess with it as part of breaking this component out.
                        //@ts-expect-error
                        placeholder={logoUrlPlaceholder}
                        src={logoUrl}
                    />
                </div>
            </div>
            <div className="flex w-full flex-col">
                <div className="flex justify-between">
                    <BodyPrimary className="font-bold">{userDisplayName}</BodyPrimary>
                    <BodyPrimary color="secondary">{shortFormatDate(commentSubmittedTS)}</BodyPrimary>
                </div>
                <div className="break-[break-word] mt-xs">{commentText}</div>
            </div>
        </div>
    );
};
